import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TermsService {
  private domainId = environment.domainId;
  public terms: any[] = [];

  constructor(
    private httpSv: HttpService
  ) { }

  async getTerms(){
    const res: any = await this.httpSv.itemIndex('term', `//${this.domainId}`);
    this.terms = res.data.data;
  }
}
